export const LOAD_BALANCE_TIME_SERIES_LONG_TERM = 'LOAD_BALANCE_TIME_SERIES_LONG_TERM'
export const RECEIVE_BALANCE_TIME_SERIES_LONG_TERM = 'RECEIVE_BALANCE_TIME_SERIES_LONG_TERM'